var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommercialArea2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 454.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478.91,312.2a7.5,7.5,0,0,0-7.5,7.5V439.27H316.82V297.32a17.52,17.52,0,0,0-17.5-17.5H212.68a17.53,17.53,0,0,0-17.5,17.5v142H40.59V319.7a7.5,7.5,0,1,0-15,0V442.77a11.51,11.51,0,0,0,11.5,11.5H474.91a11.51,11.51,0,0,0,11.5-11.5V319.7A7.49,7.49,0,0,0,478.91,312.2ZM210.18,439.27V297.32a2.51,2.51,0,0,1,2.5-2.5h86.64a2.51,2.51,0,0,1,2.5,2.5v142Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.29,409.63a16,16,0,0,0,16-16V311.82a16,16,0,0,0-16-16H350.47a16,16,0,0,0-16,16v81.84a16,16,0,0,0,16,16Zm-93.79-16V311.82a1,1,0,0,1,1-1h92.82a1,1,0,0,1,1,1v81.84a1,1,0,0,1-1,1H350.47A1,1,0,0,1,349.5,393.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.53,409.63a16,16,0,0,0,16-16V311.82a16,16,0,0,0-16-16H68.71a16,16,0,0,0-16,16v81.84a16,16,0,0,0,16,16Zm-93.78-16V311.82a1,1,0,0,1,1-1h92.82a1,1,0,0,1,1,1v81.84a1,1,0,0,1-1,1H68.71A1,1,0,0,1,67.75,393.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M490,110.57A14.55,14.55,0,0,1,504.5,96a7.5,7.5,0,0,0,7.5-7.5V70.19a7.5,7.5,0,0,0-7.5-7.5H380.69a7.5,7.5,0,0,0,0,15H497V82a29.61,29.61,0,0,0-21.07,21.06h-118V36.49A36.53,36.53,0,0,0,321.45,0H190.56a36.53,36.53,0,0,0-36.49,36.49v26.2H7.5A7.5,7.5,0,0,0,0,70.19V88.54A7.5,7.5,0,0,0,7.5,96,14.55,14.55,0,0,1,22,110.57a7.49,7.49,0,0,0,3.58,6.4V168.2H12.12A11.51,11.51,0,0,0,.62,179.7v40.84A11.51,11.51,0,0,0,12.12,232h13.5v57.71a7.5,7.5,0,0,0,15,0V232H472v57.72a7.5,7.5,0,0,0,15,0V232h13.5a11.51,11.51,0,0,0,11.5-11.5V179.7a11.51,11.51,0,0,0-11.5-11.5H487V116.54A7.48,7.48,0,0,0,490,110.57ZM169.06,36.49A21.52,21.52,0,0,1,190.55,15H321.44a21.51,21.51,0,0,1,21.49,21.49v81.83a21.52,21.52,0,0,1-21.49,21.5H190.56a21.52,21.52,0,0,1-21.49-21.5V36.49ZM497,217H15.62V183.2H497ZM40.62,168.2V118.07h90.95a7.5,7.5,0,0,0,0-15H36.07A29.61,29.61,0,0,0,15,82V77.69H154.06v40.64a36.53,36.53,0,0,0,36.49,36.49H321.44a36.53,36.53,0,0,0,36.49-36.49v-.26H472V168.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227,359.54h-6a7.5,7.5,0,1,0,0,15h6a7.5,7.5,0,0,0,0-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.28,44.93h9.19L220.9,90a19,19,0,0,0,18.56,15.08H284a19.06,19.06,0,0,0,17.74-12.26l14.71-38.94a12.06,12.06,0,0,0-11.28-16.32h-63a7.5,7.5,0,0,0,0,15H300.9l-13.2,35a4,4,0,0,1-3.7,2.56H239.46a4,4,0,0,1-3.88-3.15l-9.47-45.25a14.84,14.84,0,0,0-14.47-11.76h-9.36a7.5,7.5,0,0,0,0,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.75,111.38h-2a7.5,7.5,0,0,0,0,15h2a7.5,7.5,0,0,0,0-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.25,111.38h-2a7.5,7.5,0,0,0,0,15h2a7.5,7.5,0,0,0,0-15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialArea2);
export default __webpack_public_path__ + "static/media/CommercialArea2.5da72ab8b303d36dbc2a39f951a04bd8.svg";
export { ForwardRef as ReactComponent };